"use strict";

exports.__esModule = true;
exports.LegendSidebar = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stateDetails = require("./stateDetails");
var _styles = require("../common/styles/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LegendSidebarWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LegendSidebar__LegendSidebarWrapper",
  componentId: "sc-1ynp6p1-0"
})(["height:", "px;width:", "px;"], function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var LegendHeader = _styledComponents["default"].small.withConfig({
  displayName: "LegendSidebar__LegendHeader",
  componentId: "sc-1ynp6p1-1"
})(["display:flex;align-items:center;width:100%;font-weight:600;top:0;height:30px;"]);
var DevicesLegendsList = _styledComponents["default"].div.withConfig({
  displayName: "LegendSidebar__DevicesLegendsList",
  componentId: "sc-1ynp6p1-2"
})(["overflow-y:auto;overflow-x:hidden;height:calc(", "px - 30px);"], function (props) {
  return props.height;
});
var LegendSidebar = exports.LegendSidebar = function LegendSidebar(props) {
  var selectedStates = props.selectedStates,
    setSelectedStates = props.setSelectedStates,
    width = props.width,
    height = props.height,
    _props$states = props.states,
    states = _props$states === void 0 ? _stateDetails.stateDetails : _props$states;
  var handleClick = function handleClick(state) {
    if (selectedStates.includes(state)) {
      var newSelectedStates = [];
      for (var i = selectedStates.length - 1; i >= 0; i--) {
        if (selectedStates[i] !== state) {
          newSelectedStates.push(selectedStates[i]);
        }
      }
      setSelectedStates(newSelectedStates);
    } else {
      setSelectedStates([].concat(selectedStates, [state]));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(LegendSidebarWrapper, {
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement(LegendHeader, null, "States"), /*#__PURE__*/_react["default"].createElement(DevicesLegendsList, {
    height: height
  }, states.map(function (state) {
    return /*#__PURE__*/_react["default"].createElement(_styles.LegendWrapper, {
      onClick: function onClick() {
        return handleClick(state.key);
      },
      key: state.key,
      selected: selectedStates.includes(state.key)
    }, /*#__PURE__*/_react["default"].createElement(_styles.ColorBlock, {
      "data-key": state.key
    }), /*#__PURE__*/_react["default"].createElement(_styles.LegendText, {
      "data-testid": "UtilizationChart.Legend." + state.key
    }, state.name));
  }))));
};